export const menuItems = [
  { id: "home", labelKey: "navigation.home" },
  { id: "about", labelKey: "navigation.about" },
  { id: "services", labelKey: "navigation.services" },
  { id: "testimonials", labelKey: "navigation.testimonials" },
  { id: "gallery", labelKey: "navigation.gallery" },
  { id: "contact", labelKey: "navigation.contact" },
];
